import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useSpicePoints } from '@/composables/spice-points/useSpicePoints';
import { onBeforeUnmount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpicePointsUpdater',
  setup(__props) {

const { initAutoUpdateSpicePointsBalance, stopAutoUpdateSpicePointsBalance } = useSpicePoints();

initAutoUpdateSpicePointsBalance();

onBeforeUnmount(() => {
  stopAutoUpdateSpicePointsBalance();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})